/* eslint-disable*/
import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
//import { BsChevronRight } from 'react-icons/bs'
import Product from 'components/home/Product'
import { useRequest } from 'hooks/useRequest'
//import { Link } from 'react-router-dom';
//import SwitchToggle from 'components/form-elements/switchToggle/SwitchToggle';
import auth from 'utils/Auth'
import { useDispatch, useSelector } from 'react-redux'
import { setCategories, setProducts } from 'redux/product/productSlice'
import useWindowSize from 'hooks/useWindowSize'
//import SimpleAccordion from 'components/accordion/SimpleAccordion';
import ApprovalModal from 'components/approvalModal/ApprovalModal'
import { getAllBasketFunc } from 'redux/features/general/generalSlice'
import { toast } from 'react-toastify'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import BasketCardDrawer from 'containers/basketCardDrawer/BasketCardDrawer'
import { Helmet } from 'react-helmet'
import InfiniteScroll from 'react-infinite-scroll-component'
import LoaderTwo from './LoaderTwo'
import useTranslate from 'hooks/useTranslate'
import { dataLayerPush } from 'utils/Datalayer'



const Home = () => {
	const [request, loading] = useRequest()
	const [catalogRequest] = useRequest()
	const [sliderRequest, sliderLoading] = useRequest()
	const dispatch = useDispatch()
	const {t} = useTranslate()
	const { product, general } = useSelector((state) => state)
	const { categoryList, productList } = product
	const { openStatus, useTrigger } = general
	const [allSliders, setAllSliders] = useState([])
	const [allBanners, setAllBanners] = useState([])
	const [isOpenDrawer, setIsOpenDrawer] = useState(false)
	const [singleDrawerProduct, setSingleDrawerProduct] = useState({ id: null, item: null }) //redux kullanmadım.Baska bi yerde lazım degil cünkü.Bilginize...
	// const [authModal, setAuthModal] = useState(!auth.isHaveToken())
	const { width } = useWindowSize()
	const [approvalModal, setApprovalModal] = useState({ open: false, order: null, type: null })

	const navigate = useNavigate()
	const location = useLocation()
	const [imageLoading, setImageLoading] = useState(true)
	const [scrollOptions, setScrollOptions] = useState({
		hasNextPage: false,
		pageIndex: 0,
		totalCount: 0,
		pageSize: 12,
	})
	const headerOptions = {
		RestaurantId: auth?.getUserChoises()?.restaurantId,
		DeliveryType: auth?.getUserChoises()?.deliveryType,
		NeighbourhoodId: auth?.getUserChoises()?.neighbourhoodId,
		RegionId: auth?.getUserChoises()?.regionId,
	}
	useEffect(() => {
		return () => {
			dispatch(setProducts([]))
			setScrollOptions({
				hasNextPage: false,
				pageIndex: 0,
				totalCount: 0,
				pageSize: 10,
			})
			window.scrollTo(0, 0)
		}
	},[])


	useEffect(() => {
		catalogRequest('/Catalog/Products', {
			method: 'GET',
			params: {
				PageIndex: scrollOptions.pageIndex,
				PageSize: scrollOptions.pageSize,
				isHomePage: true,
			},
			headers: headerOptions,
		}).then((res) => {
			if (res?.data?.ok) {
				if (scrollOptions.pageIndex == 0) {
					dispatch(setProducts(res?.data?.result?.items))
					setScrollOptions((prev) => ({ ...prev, hasNextPage: res.data.result.hasNextPage }))
				}
				else {
					dispatch(setProducts([...productList.concat(res?.data?.result?.items)]))
					setScrollOptions((prev) => ({ ...prev, hasNextPage: res.data.result.hasNextPage }))
				}
				if(res?.data?.result?.items.length > 0){
					dataLayerPush({ ecommerce: null });
					dataLayerPush({
						event:"view_item_list",
						ecommerce: {
							item_list_name: "Listeleme Sayfası",
							currency: "TRY",
							items: [...res?.data?.result?.items]?.map((prev, i) => ({
								item_id: prev.id,
								item_name: prev.name,
								affilication: "Tavuk Dünyası",
								discount: prev.discountAmount,
								index: i,
								item_brand: "Tavuk Dünyası",
								item_category: prev.categories?.[0]?.value,
								item_category2: prev.categories?.[1]?.value ? prev.categories?.[1]?.value : "",
								item_category3: prev.categories?.[2]?.value ? prev.categories?.[2]?.value: "",
								item_list_name: "Listeleme Sayfası",
								price: prev.price
							}))
						}
					})
				}	
			}

		})
	},[scrollOptions.pageIndex, useTrigger])
	useEffect(() => {
		if (!openStatus) {
			sliderRequest('/Slider', {
				method: 'GET',
				headers: headerOptions,
			}).then((res) => {
				if (res) {
					setAllSliders(res?.data?.result)
					if(res?.data?.result?.length > 0) {
						let slider = res.data.result[0]
						dataLayerPush({ ecommerce: null });
						dataLayerPush({
							event:"view_promotion",
							ecommerce: {
								promotion_id: slider.title,
								promotion_name: slider.title,
								creative_name: width <= 700 ? slider.mobileImageLink : slider.backgroundImageLink
							}
						})
					}
				}
			})
			request('/Banner', {
				method: 'GET',
				headers: headerOptions,
			}).then((res) => {
				if (res) {
					setAllBanners(res?.data?.result)
				}
			})
			request('/Catalog/Categories', {
				method: 'GET',
				//Statik olarak ekleniyor, servis bağlandıktan sonra kaldırılacak..
				headers: headerOptions,
			}).then((res) => {
				if (res?.data?.ok) {
					dispatch(setCategories(res.data.result))
				}
			})
		}
	}, [openStatus])
	useEffect(() => {
    const token = auth.isHaveToken()
		const parameters = auth.getUserChoises()

    if (
			token &&
			(!parameters?.deliveryType ||
				!parameters?.neighbourhoodId ||
				!parameters?.restaurantId ||
				(parameters?.deliveryType == 2 && !parameters?.regionId))
		) {
			return navigate('/teslimat-secimi')
		}
	}, [openStatus, location.pathname])
	const fetchNewFeed = async () => {
		if (scrollOptions.hasNextPage) {
			setScrollOptions((prev) => ({ ...prev, pageIndex: prev.pageIndex + 1 }))
		}
	}
	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,

		afterChange: (currentSlide) => {
			if(allSliders){
				let slider = allSliders[currentSlide]
				if(!slider) return
				dataLayerPush({ ecommerce: null });
				dataLayerPush({
					event:"view_promotion",
					ecommerce: {
						promotion_id: slider.title,
						promotion_name: slider.title,
						creative_name: width <= 700 ? slider.mobileImageLink : slider.backgroundImageLink
					}
				})
			}
		},

		nextArrow:<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="chevron-right">
		<path id="Path (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M23.2322 8.23223C24.2085 7.25592 25.7915 7.25592 26.7678 8.23223L56.7678 38.2322C57.7441 39.2085 57.7441 40.7915 56.7678 41.7678L26.7678 71.7678C25.7915 72.7441 24.2085 72.7441 23.2322 71.7678C22.2559 70.7915 22.2559 69.2085 23.2322 68.2322L51.4645 40L23.2322 11.7678C22.2559 10.7915 22.2559 9.20854 23.2322 8.23223Z" fill="#fff"/>
		</g>
		</svg>,
		prevArrow:<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="chevron-left">
		<path id="Path (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M56.7678 8.23223C57.7441 9.20854 57.7441 10.7915 56.7678 11.7678L28.5355 40L56.7678 68.2322C57.7441 69.2085 57.7441 70.7915 56.7678 71.7678C55.7915 72.7441 54.2085 72.7441 53.2322 71.7678L23.2322 41.7678C22.2559 40.7915 22.2559 39.2085 23.2322 38.2322L53.2322 8.23223C54.2085 7.25592 55.7915 7.25592 56.7678 8.23223Z" fill="#fff"/>
		</g>
		</svg>,
	}

	const promotionsSliderDataLayerClick = (slider) => {
		if(slider){
			dataLayerPush({ ecommerce: null });
			dataLayerPush({
				event:"select_promotion",
				ecommerce: {
					promotion_id: slider.title,
					promotion_name: slider.title,
					creative_name: width <= 700 ? slider?.mobileImageLink : slider.backgroundImageLink
				}
			})
		}
	} 

	const settingsCategory = {
		dots: false,
		infinite: true,
		speed: 2000,
		autoplay: false,
		autoplaySpeed: 3000,
		slidesToShow: categoryList?.length < 7 ? categoryList?.length : 7,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 1500,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 1180,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					initialSlide: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					arrows: false,
				},
			},
		],
		nextArrow:<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="chevron-right">
		<path id="Path (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M23.2322 8.23223C24.2085 7.25592 25.7915 7.25592 26.7678 8.23223L56.7678 38.2322C57.7441 39.2085 57.7441 40.7915 56.7678 41.7678L26.7678 71.7678C25.7915 72.7441 24.2085 72.7441 23.2322 71.7678C22.2559 70.7915 22.2559 69.2085 23.2322 68.2322L51.4645 40L23.2322 11.7678C22.2559 10.7915 22.2559 9.20854 23.2322 8.23223Z" fill="#96004B"/>
		</g>
		</svg>,
		prevArrow:<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="chevron-left">
		<path id="Path (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M56.7678 8.23223C57.7441 9.20854 57.7441 10.7915 56.7678 11.7678L28.5355 40L56.7678 68.2322C57.7441 69.2085 57.7441 70.7915 56.7678 71.7678C55.7915 72.7441 54.2085 72.7441 53.2322 71.7678L23.2322 41.7678C22.2559 40.7915 22.2559 39.2085 23.2322 38.2322L53.2322 8.23223C54.2085 7.25592 55.7915 7.25592 56.7678 8.23223Z" fill="#96004B"/>
		</g>
		</svg>,
	}

	const settingsCampaigns = {
		dots: false,
		infinite: true,
		speed: 2000,
		autoplay: true,
		autoplaySpeed: 4000,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		responsive: [
			{
				breakpoint: 1500,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 1180,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					//dots: true
				},
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 1,
					arrows: false,
				},
			},
		],
	
	}
	const clearBasket = () => {
		if (approvalModal.type == 'DELETE') {
			request(`/ShoppingCart/RemoveItem?id=${approvalModal.order.id}`, {
				method: 'POST',
				//data: {id : id},
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
			}).then((res) => {
				if (res.data) {
					dispatch(getAllBasketFunc(res?.data?.result))
					toast.success(t('successfullToast',{type:t('delete'),name:''}))
					setApprovalModal({ open: false, order: null, type: null })
				}
			})
		} else {
			request('/ShoppingCart/ClearCart', {
				method: 'POST',
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
			}).then((res) => {
				if (res) {
					dispatch(getAllBasketFunc([]))
					setApprovalModal({ open: false, order: null, type: null })
				}
			})
		}
	}


	return <div className='home'>
			<LoaderTwo isDataLoading={loading} />
			<Helmet>
				<title>{t('homePageMetaTitle')}</title>
				<meta name='description' content={t('homePageMetaDesc')} />
			</Helmet>
			{/* sliderları aynı yerde tutmak istedim(Yönetimi kolaylastırmak icin) */}
			{/* {authModal && <AllModal authModalContent={authModalContent} setAuthModal={setAuthModal} />} */}

			
				<div className='home-slider'>
					{
						imageLoading && <div className="skeleton-home-slider">
						<div className="skeleton"/>
					</div>
					}
				<Slider {...settings} >
					{allSliders?.map((slider, i) => (
						<div key={i} style={{visibility: imageLoading ? 'hidden' : 'visible'}} className='home-slider-cont'>
							<div className='home-slider-cont-text'>
								{/*<div className='home-slider-cont-text-title'>{slider.title}</div>*/}
								{/*<div className='home-slider-cont-text-body'>{slider.descripttion?.substring(0, 200)}</div>*/}
								{/* <div className='home-slider-cont-text-btn'>{slider.buttonText}</div> */}
							</div> 
							{
								slider?.buttonLink ? <a href={slider?.buttonLink} onClick={() => promotionsSliderDataLayerClick(slider)}>
								<img onLoad={() => setImageLoading(false)} alt={slider?.title} className='headerSlider' src={width <= 700 ? slider?.mobileImageLink : slider.backgroundImageLink} />
								</a> :<img onLoad={() => setImageLoading(false)} alt={slider?.title} className='headerSlider' src={width <= 700 ? slider?.mobileImageLink : slider.backgroundImageLink} />
							}
						</div>
					))}
				</Slider>
			</div>
			{
				!loading && !sliderLoading && categoryList?.length > 0 && <div className='home-category-slider'>
				<Slider {...settingsCategory}>
					{categoryList?.map((ct) => (
						<div onClick={() => navigate(`/kategori/${ct?.url}`)} key={ct.id} className='home-category-slider-cont'>
							<img loading='lazy' src={ct.imagePath ? ct.imagePath : ""} alt={ct.name} />
							<div>{ct.name}</div>
						</div>
					))}
				</Slider>
			</div>
			}
			{
				!loading && !sliderLoading && allBanners?.length > 0 && <div className='home-campaign-slider'>
				<Slider {...settingsCampaigns}>
					{allBanners?.map((banner, i) => (
						<Link to={banner.visualConnectionPath} key={i} className='home-campaign-slider-cont'>
							<img loading='lazy' src={banner.imageLink} alt={banner.name} />
						</Link>
					))}
				</Slider>
			</div>
			}
			{
				!loading && !sliderLoading && productList?.length > 0 && <div className='home-products'>
				<InfiniteScroll
					dataLength={productList.length}
					next={fetchNewFeed}
					hasMore={scrollOptions.hasNextPage}
					loader={<div className='home-products-container mt-4'>
							<div className='product'>
								<div className="skeleton skeleton-card-img"/>
								<div className='skeleton skeleton-text'/>
								<div className='skeleton skeleton-text'/>
								<div className='skeleton skeleton-footer'/>
							</div>
							<div className='product'>
								<div className="skeleton skeleton-card-img"/>
								<div className='skeleton skeleton-text'/>
								<div className='skeleton skeleton-text'/>
								<div className='skeleton skeleton-footer'/>
							</div>
							<div className='product'>
								<div className="skeleton skeleton-card-img"/>
								<div className='skeleton skeleton-text'/>
								<div className='skeleton skeleton-text'/>
								<div className='skeleton skeleton-footer'/>
							</div>
						</div>}
					>
					<div className='home-products-container'>
						{productList?.map((product, i) => (
							<Product
								setSingleDrawerProduct={setSingleDrawerProduct}
								isOpenDrawer={isOpenDrawer}
								setIsOpenDrawer={setIsOpenDrawer}
								key={i}
								product={product}
							/>
						))}
					</div>
				</InfiniteScroll>
			</div>
			}
			<ApprovalModal
				onClose={approvalModal.open}
				title={approvalModal.type == 'DELETE' ? t('youRemoveOrderFromList')  : t('youRemoveProductFromCard')}
				desc={approvalModal.type == 'DELETE' ? t('sureYouWantRemoveFromListOrder') : t('sureYouWantClearBasket')}
				closeModal={() => setApprovalModal({ open: false, order: null, type: null })}
				onApproval={clearBasket}
			/>
			<BasketCardDrawer
				isOpenDrawer={isOpenDrawer}
				setIsOpenDrawer={setIsOpenDrawer}
				singleDrawerProduct={singleDrawerProduct}
				setApprovalModal={setApprovalModal}
				setSingleDrawerProduct={setSingleDrawerProduct}
			/>
		</div>
}

export default Home
